import { useUniversalAuth } from "@wtc/ui";
import { USER_ROLES } from "@/lib/constants/user-types";
import { useAllUsers } from "./user-queries";

export function useUserStats() {
  const { data: allUsers } = useAllUsers();

  return {
    totalUsers: allUsers?.length || 0,
    activeUsers: allUsers?.filter((user) => user.is_active).length || 0,
    employeeUsers:
      allUsers?.filter((user) => (user.roles?.name || user.role) === USER_ROLES.WTC_EMPLOYEE)
        .length || 0,
    adminUsers:
      allUsers?.filter((user) => (user.roles?.name || user.role) === USER_ROLES.WTC_ADMIN).length ||
      0,
    clientUsers:
      allUsers?.filter((user) => (user.roles?.name || user.role) === USER_ROLES.CLIENT_USER)
        .length || 0,
    crmUsers:
      allUsers?.filter((user) => (user.roles?.name || user.role) === USER_ROLES.WTC_CRM).length ||
      0,
    isLoading: false,
  };
}

export function useUserPermissions() {
  const { appUser } = useUniversalAuth();
  const userRole = appUser?.roles?.name || appUser?.role;

  return {
    isAdmin: userRole === "wtc_admin",
    isEmployee: ["wtc_employee", "wtc_admin", "wtc_crm"].includes(userRole || ""),
    isCRM: userRole === "wtc_crm",
    isClient: userRole === "client_user",
    canManageUsers: ["wtc_employee", "wtc_admin", "wtc_crm"].includes(userRole || ""),
    canDeleteUsers: userRole === "wtc_admin",
    canViewAllData: ["wtc_employee", "wtc_admin", "wtc_crm"].includes(userRole || ""),
  };
}
